// extracted by mini-css-extract-plugin
export default {"agendaView":"AgendaView-module__agendaView___1FX9R"};